import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentInformationDetail = ({
  banner,
  detail,
  filterEvaluation,
  refinementCriteria
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      as: "div",
      children: detail
    }), banner, filterEvaluation, refinementCriteria]
  });
};
export default EnrollmentInformationDetail;